import React from 'react'
import axios from 'axios';
import utils from '../Utils';
import { Button } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Link } from 'react-router-dom'

import style from 'style/Article.css'

const blogimage = 'https://www.tebinja.com/img/uploads/blog/'
class Article extends React.Component {
  componentDidMount() {

  }
  fullName = (patient) => {
    return patient.fname + ((patient.lname && patient.fname) && ' ') + patient.lname
  }
  showQuiz = (quizId) => {

  }
  blogImage = (img) => {
    return blogimage + img
  }
  render() {
    const { article } = this.props
    return (
      <div class="article-item">
        <Link to={`/article/${article.id}`}>
          <div class='image-section' style={{ backgroundImage: `url("${this.blogImage(article.featuredImage)}")` }}>
            {/* <img src='https://www.tebinja.com/img/uploads/blog/15470.jpeg' /> */}
          </div>
          <div class='info'>
            <div class='bold title'>{article.title}</div>

            <div class='kv-label article-desc'>
              {article.description}

            </div>


          </div>
        </Link>
      </div>
    )
  }
}
export default Article;